import { render, staticRenderFns } from "./UploadDialog.vue?vue&type=template&id=ecb17280&scoped=true"
import script from "./UploadDialog.vue?vue&type=script&lang=js"
export * from "./UploadDialog.vue?vue&type=script&lang=js"
import style0 from "./UploadDialog.vue?vue&type=style&index=0&id=ecb17280&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb17280",
  null
  
)

export default component.exports